import type { TFunction } from 'i18next'
import { isChecklistAnswerItemArray, type ChecklistAnswerItem } from '@/lib/action-modules/registry/subtypes/checklist'
import type { SubtypeState } from '@/lib/action-modules/registry/types'

/** Checklist/dropdown items configured on a subtype (empty for other subtype kinds). */
export function checklistItemsOf(s: SubtypeState): ChecklistAnswerItem[] {
  const value = s.properties.checklistItems
  return isChecklistAnswerItemArray(value) ? value : []
}

/**
 * Conditions reference elements by their persisted backend id. While any subtype or checklist
 * item is still unsaved (id == null) those ids aren't stable, so condition editing is locked
 * until the whole module has been saved once.
 */
export function areConditionsLocked(allSubtypes: SubtypeState[]): boolean {
  return allSubtypes.some(s => s.subtype.id == null || checklistItemsOf(s).some(i => i.id == null))
}

/** Display label for a subtype: its name, else its type display name. */
export function subtypeLabel(s: SubtypeState, t: TFunction): string {
  const name = s.properties.name
  return typeof name === 'string' && name.trim().length > 0 ? name : t(s.definition.nameKey)
}
